import { Box, Button, CloseButton, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import React from 'react';
import { BiCtaNames, BiModalTypes } from '../../../../../../bi/types';
import { useBiLogger } from '../../../../../../hooks/use-bi-logger';
import { useAltTextScreenContext } from '../alt-text-screen-wrapper';
export const AltTextScreenAiWarningPopover = () => {
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    actions: {
      handleClickApply,
      setShowPopoverAiWarning
    }
  } = useAltTextScreenContext();
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "24px 16px",
    position: "relative",
    width: "260px"
  }, /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    right: "8px",
    top: "8px"
  }, /*#__PURE__*/React.createElement(CloseButton, {
    size: "medium",
    skin: "dark",
    onClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.X,
        modalType: BiModalTypes.ReviewRecentChanges
      });
      setShowPopoverAiWarning(false);
    }
  })), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "bold"
  }, t('accessibility-wizard.rules-list.alt-image-rule-fixer.button.apply.tooltip.header')), /*#__PURE__*/React.createElement(Box, {
    marginTop: "4px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, t('accessibility-wizard.rules-list.alt-image-rule-fixer.button.apply.tooltip.content'))), /*#__PURE__*/React.createElement(Box, {
    gap: "SP1",
    marginTop: "16px"
  }, /*#__PURE__*/React.createElement(Box, {
    border: "1px solid",
    borderColor: "B10",
    borderRadius: "4px",
    width: "93px"
  }, /*#__PURE__*/React.createElement(Button, {
    priority: "primary",
    size: "tiny",
    skin: "light",
    onClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.ReviewNow,
        modalType: BiModalTypes.ReviewRecentChanges
      });
      setShowPopoverAiWarning(false);
    }
  }, t('accessibility-wizard.rules-list.alt-image-rule-fixer.button.apply.tooltip.review-now-button'))), /*#__PURE__*/React.createElement(Box, {
    border: "1px solid",
    borderColor: "B10",
    borderRadius: "4px",
    width: "SP10"
  }, /*#__PURE__*/React.createElement(Button, {
    priority: "primary",
    size: "tiny",
    skin: "light",
    onClick: async () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.Apply,
        modalType: BiModalTypes.ReviewRecentChanges
      });
      await handleClickApply();
    }
  }, t('accessibility-wizard.rules-list.alt-image-rule-fixer.button.apply.tooltip.apply-button')))));
};
//# sourceMappingURL=alt-text-screen-ai-warning-popover.js.map